import SmartCarousel from "../../SmartCarousel";

export default function HotelSlider({ images, children, className = "", priority = false }) {
  return (
    <SmartCarousel
      images={images}
      priority={priority}
    >
      {children}
    </SmartCarousel>
  );
}
